import BudgetExpensesByCategoryView from './BudgetExpensesByCategoryView';
import OverallProjectExpenses from './OverallProjectExpenses';
import { EditOutlined } from '@ant-design/icons';
import { Card, Button } from 'antd';

const ProjectBudgetExpensesPlan = ({
  budgetPlanData,
  selectedVersion
}) => {
  const {
    totalsData,
    expensesByCategoryData,
    budgetPlanSettings,
    editingSection,
    isReadOnly,
    setExpensesData,
    setBudgetPlanSettings,
    setEditingSection,
    setHasIntents,
    setCategoriesWithoutDate,
    setValidateRowsFn,
    loadBudgetExpensesPlanData,
    onStartEditing,
  } = budgetPlanData;

  return (
    <>
      <Card
        title='Splošni stroški'
        style={{ marginBottom: 20 }}
        extra={isReadOnly && <Button onClick={onStartEditing}><EditOutlined /> Uredi</Button>}
      >
        <OverallProjectExpenses
          budgetPlanData={budgetPlanSettings}
          setBudgetPlanData={setBudgetPlanSettings}
          totals={totalsData}
          readOnly={isReadOnly}
        />
      </Card>
      <Card title='Stroški po kategorijah'>
        <BudgetExpensesByCategoryView
          expensesData={expensesByCategoryData}
          setExpensesData={setExpensesData}
          editingSection={editingSection}
          setEditingSection={setEditingSection}
          onDataRefresh={() => loadBudgetExpensesPlanData(selectedVersion === 'draft' ? null : selectedVersion, false)}
          onHasIntentsChange={setHasIntents}
          onValidationChange={setCategoriesWithoutDate}
          onRowValidationChange={(fn) => setValidateRowsFn(() => fn)}
          readOnly={isReadOnly}
        />
      </Card>
    </>
  );
};

export default ProjectBudgetExpensesPlan;
